<template>
    <div class="f fh fa-c dw-10 sm-b-xs" v-if="lbl">
        <slot name="labelLeft"></slot>
        <span class="fg ath-form-input-label">{{ lbl | athT }}<slot name="labelAfter"></slot></span>
        <slot name="labelRight"></slot>
    </div>
</template>

<script>
export default {
    name: 'mead-form-label',
    props: {
        /**
         * Label i18n key rendered as text. The whole component only renders when this is truthy.
         */
        lbl: {type: [String], default: () => ''},
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/_variables.scss';

.ath-form-input-label {
    font-family: $ff-b;
    font-weight: 400;
    line-height: $lh-xs;
    font-size: $fs-s;
    color: var(--c-txt);
}
</style>
